// [ai] search: a box over the transcript search (`search` query, debounced); a hit plays at its second through the host.
import { useEffect, useState } from "react";
import { useAtlas } from "../../sdk/react";
import { ErrorCard } from "../cards";
import { querySpec, useHostQuery, type WidgetProps } from "./hooks";
import { Rows } from "./Rows";
import type { Schema } from "../props";
export const SEARCH_PROPS: Schema = { q: { type: "string" }, limit: { type: "number" }, placeholder: { type: "string" } };
type Hit = { id: string; title: string; date?: string; t: number; who?: string; snippet?: string };
const stamp = (t: number) => `${Math.floor(t / 60)}:${String(Math.floor(t % 60)).padStart(2, "0")}`;
export function Search({ spec }: WidgetProps) {
  const p = (spec.props ?? {}) as { q?: string; limit?: number; placeholder?: string }; const host = useAtlas();
  const [typed, setTyped] = useState(p.q ?? ""); const [q, setQ] = useState(typed);
  useEffect(() => { if (typed === q) return; const id = setTimeout(() => setQ(typed), 250); return () => clearTimeout(id); }, [typed, q]);
  const r = useHostQuery<{ hits: Hit[] }>(querySpec(spec, "search", { q, limit: p.limit ?? 6 }), q.trim().length > 0);
  return (
    <div className="at-cat at-cat-search">
      <input type="search" className="at-cat-in" value={typed} placeholder={p.placeholder ?? "Search the record…"} aria-label="Search" onChange={e => setTyped(e.target.value)} />
      {r.error ? <ErrorCard text={r.error.message} /> : !q.trim() ? <p className="at-cat-empty">Type to search.</p> : r.data === undefined ? <p className="at-cat-empty">Searching…</p> :
        <Rows rows={r.data.hits.map(h => ({ key: `${h.id}@${h.t}`, href: `rec:${h.id}?t=${h.t}`, title: h.snippet || h.title, sub: `${h.title} · ${stamp(h.t)}${h.who ? " · " + h.who : ""}`, onOpen: () => void host.media.play({ rec: h.id, t: h.t }) }))} empty="No hits." />}
    </div>
  );
}
